



















































import Vue from "vue";
import EditNumber from "@/components/end_parts/EditNumber.vue";

export default Vue.extend({
  components: {
    EditNumber,
  },
  props: {
    numberBoxParam: {
      type: Object,
      default: Object,
    },
    numberBoxKey: {
      type: String,
      default: String,
    },
    numberBoxIndex: {
      type: Number,
      default: Number,
    },
  },
  data() {
    return {
      JsonParam: Object,
    };
  },
  watch: {
    numberBoxParam: {
      handler() {
        this.reload();
      },
      deep: true,
    },
  },
  methods: {
    reload() {
      this.JsonParam = this.numberBoxParam[this.numberBoxKey];
    },
    SendNumberBox() {
      this.$emit("NumberBoxEvent");
    },
    errorEvent(event: boolean) {
      this.$emit("hasError", event);
    },
  },
});
